import { FC } from 'react'

import { cn } from '@/app/utils'
import { UploadedFileType } from '@/components/shared/file-uploader'

import FileCard from './FileCard'
import { cardMapper } from './FileCard.service'

type Props = {
  files: UploadedFileType[]
  onDelete: (id: string) => void
  handleFileAction: (
    name: string,
    image?: string,
    file?: UploadedFileType
  ) => Promise<void>
  disabled?: boolean
  className?: {
    listClassName?: string
    rootClassName?: string
    fileNameClassName?: string
  }
}

const UploadedFilesList: FC<Props> = ({
  files,
  onDelete,
  handleFileAction,
  disabled,
  className
}) => {
  if (files.length === 0) {
    return null
  }

  return (
    <div className={cn('mb-24 flex flex-col gap-8', className?.listClassName)}>
      {files.map(file => (
        <FileCard
          key={file.id}
          {...cardMapper(file)}
          onDelete={onDelete}
          withoutDownloading={file.error}
          disabled={disabled}
          handleFileAction={handleFileAction}
          className={{
            rootClassName: className?.rootClassName
          }}
        />
      ))}
    </div>
  )
}

export default UploadedFilesList
